import { applySnapshot, types } from 'mobx-state-tree';

const UserPermissionCheck = types
  .model('UserPermissionCheck', {
    isPermissionCheck: types.maybeNull(types.boolean)
  })
  .actions((self) => ({
    set(response) {
      applySnapshot(self, response);
    }
  }));

export default UserPermissionCheck;
